import React from "react";
import { useSelector } from "react-redux";
import SideBar from "../../../components/b2b/SideBar";
import Header from "../../../components/landingPage/Header";
import Documentation from "./WLDocs";


const MainDocsPage = () => {
  const { token } = useSelector((state) => state.auth);

  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex w-full h-full ">
        <SideBar />
        <div className="flex w-full h-full ">
          <Documentation/>
        </div>
      </div>
    </div>
  );
};

export default MainDocsPage;
